import APIController from '../core-api-controller';

export const loginUserApi = (data) => {
  const path = `${APIController.baseUrl}/client_users/sign_in`;
  return APIController.postCallback(path, data, true);
};

export const registerUserApi = (data) => {
  const path = `${APIController.baseUrl}/client_users`;
  return APIController.postCallback(path, data, true);
};

export const logoutUserApi = () => {
  const path = `${APIController.baseUrl}/logout_device`;
  return APIController.deleteCallback(path, {}, true);
};

export const fetchUserData = (paramsObj = {}) => {
  const path = `${APIController.endpointApi}/current_user`;
  return APIController.getApiCallback(path, paramsObj);
};

export const forgotPasswordApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/client_user/users/process_authentication_request${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const resetPasswordApi = (data) => {
  const path = `${APIController.endpointApi}/client_user/users/account_password_reset`;
  return APIController.postCallback(path, data);
};

export const processConfirmationApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/client_user/users/process_authentication_request${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const onboardingApi = ({ data, token = '' }) => {
  const path = `${APIController.endpointApi}/external/onboarding_tokens/${token}/onboard_client_patient`;
  return APIController.postExternalCallback(path, data, true);
};
